import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './index.css'; // Add your custom CSS here

const Steps = () => {
    const imgCDNURL = process.env.REACT_APP_CDN + "eaimortgage/images/";
    return (
        <section className="steps-section">
            <Container className="steps-container">
                <Row className="steps-row">
                    <Col lg={3} className="step1-column">
                        <Card className="step1-card">
                            <div className="step1-number">1</div>
                            <img src={imgCDNURL + "first-step.svg"} alt={`Step First Icon`} className="step1-icon" />
                            <Card.Body>
                                <Card.Text className="step1-text">Find a local loan officer or work with one online and get started with your online application.</Card.Text>
                                <Button variant="warning" className="step1-button" onClick={() => window.open("https://www.swmc.com/ApplyNow/?c=evolution", "_blank")}
                                >Get Started</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={3} className="step2-column">
                        <Card className="step2-card">
                            <div className="step2-number">2</div>
                            <img src={imgCDNURL + "second-step.svg"} alt={`Step 2 Icon`} className="step2-icon" />
                            <Card.Body>
                                <Card.Text className="step2-text">Get TRU Approved! With a Thoroughly Reviewed & Underwritten (TRU) loan approval, take the fast lane while removing contingencies from your offer.</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={3} className="step3-column">
                        <Card className="step3-card">
                            <div className="step3-number">3</div>
                            <img src={imgCDNURL + "third-step.svg"} alt={`Step 3 Icon`} className="step3-icon" />
                            <Card.Body>
                                <Card.Text className="step3-text">Shop Confidently knowing exactly how much you can afford and make an offer on your dream home.</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={3} className="step4-column">
                        <Card className="step4-card">
                            <div className="step4-number">4</div>
                            <img src={imgCDNURL + "fourth-step.svg"} alt={`Step 4 Icon`} className="step4-icon" />
                            <Card.Body>
                                <Card.Text className="step4-text">Finalize and Close. Finish up the documentation, appraisal, and close to get the keys to move in. Celebrate and insert your happy dance here.</Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Steps;
